import HeroLayout from "../../../Components/LayoutContainers/HeroLayout";
import FiImage from "../../../Asset/images/1q.png"
import SeImage from "../../../Asset/images/2q.png"
import ThImage from "../../../Asset/images/3q.png"
import FoImage from "../../../Asset/images/sd.png"
import FifImage from "../../../Asset/images/5q.png"
import SiImage from "../../../Asset/images/6q.png"
import Fe2e from "../../../Asset/images/fe1.png"
import {Grid} from "@mui/material";
import {CurrentUser} from "../../../utils/Hooks/currentUser";
import {useNavigate} from "react-router-dom";

const StudentLandingPage = () => {
    const navigate = useNavigate();
    return (
        <HeroLayout>
            <Grid container spacing={"2rem"} pb={"10vh"}>
                <Grid item xs={12} md={12} lg={6} textAlign={{xs: "center", lg: "end", }} sx={{cursor: "pointer"}}
                      onClick={() => navigate("/studentsalamat")}>

                    <img src={FiImage} style={{height: "40vh"}}/>
                </Grid>
                <Grid item xs={12} md={12} lg={6} sx={{cursor: "pointer"}}
                      textAlign={{xs: "center", lg: "start"}}
                      onClick={() => navigate("/studentpersonal ")}>
                    <img src={CurrentUser().user.Sex === "F" ? Fe2e : SeImage} style={{height: "40vh"}}/>
                </Grid>
                <Grid item xs={12} md={12} lg={6} textAlign={{xs: "center", lg: "end",  }} sx={{cursor: "pointer"}}
                      onClick={() => navigate("/lifestyle")}>
                    <img src={ThImage} style={{height: "40vh"}}/>
                </Grid>
                <Grid item xs={12} md={12} lg={6} sx={{cursor: "pointer"}} textAlign={{xs: "center", lg: "start",}}
                      onClick={() => navigate("/StudentAmoozshi")}>
                    <img src={FoImage} style={{height: "40vh"}}/>
                </Grid>
                <Grid item xs={12} md={12} lg={6} textAlign={{xs: "center", lg: "end" }}  sx={{cursor: "pointer"}}
                      onClick={() => navigate("/studentforum")}>
                    <img src={FifImage} style={{height: "40vh"}}/>
                </Grid>
                <Grid item xs={12} md={12} lg={6}textAlign={{xs: "center", lg: "start"}} sx={{cursor: "pointer"}}
                      onClick={() => navigate("/studentnoskhe")}>
                    <img src={SiImage} style={{height: "40vh"}}/>
                </Grid>
            </Grid>
        </HeroLayout>
    )
}
export default StudentLandingPage 